<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t('Room-Types') }} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                flat=""
                solo-inverted=""
                hide-details
                v-model="searchara"
                :label="$t('Search')"
                append-icon="search"
                @click:append="getList"
                v-on:keyup.13="getList()"
              >
              </v-text-field>

              <v-btn class="white--text" flat @click="openRoomTypeAddDialog()">
                <span class="hidden-sm-and-down">{{ $t('Add-v2', { value: $t('Room-type')}) }} </span>
                <v-icon right dark>add</v-icon>
              </v-btn>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table
                                :headers="headersadres"
                                :rows-per-page-items="[50]"
                                :items="itemsRoomType"
                                :expand="expand"
                                item-key="Kod"
                              >
                                <template slot="items" slot-scope="props">
                                  <tr item>
                                    <td>
                                      <v-btn
                                        v-if="props.item.AltOdaTipleri != null"
                                        fab
                                        icon
                                        small
                                        @click="
                                          props.expanded = !props.expanded
                                        "
                                      >
                                        <v-icon align-center
                                          >expand_more</v-icon
                                        >
                                      </v-btn>
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.Kod }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.Aciklama }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.Yetiskin }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.Cocuk1 }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.Cocuk2 }}
                                    </td>
                                    <td
                                      class="
                                        justify-end
                                        align-center
                                        full-heigth
                                        layout
                                        px-0
                                      "
                                    >
                                      <v-tooltip bottom>
                                        <v-btn
                                          icon
                                          small
                                          slot="activator"
                                          flat
                                          @click="
                                            openRoomTypeUpateDialog(props.item)
                                          "
                                        >
                                          <v-icon color="green"
                                            >system_update_alt</v-icon
                                          >
                                        </v-btn>
                                        <span>{{ $t('Update') }}</span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                        <v-btn
                                          icon
                                          small
                                          slot="activator"
                                          flat
                                          @click="openLowerRoomType(props.item)"
                                        >
                                          <v-icon color="indigo"
                                            >meeting_room</v-icon
                                          >
                                        </v-btn>
                                        <span>Alt Oda Tipi Ekle</span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                        <v-btn
                                          @click="deleteRoomType(props.item)"
                                          icon
                                          small
                                          slot="activator"
                                          flat
                                        >
                                          <v-icon color="error">delete</v-icon>
                                        </v-btn>
                                        <span> {{  $t('Delete') }} </span>
                                      </v-tooltip>
                                    </td>
                                  </tr>
                                </template>

                                <template v-slot:expand="props">
                                  <v-card
                                    flat
                                    v-if="props.item.AltOdaTipleri != null"
                                  >
                                    <v-card-text>
                                      <v-data-table
                                        :headers="headersadresLower"
                                        :rows-per-page-items="[50]"
                                        :items="props.item.AltOdaTipleri"
                                        hide-actions
                                        class="elevation-1 red"
                                      >
                                        <template
                                          slot="items"
                                          slot-scope="props"
                                        >
                                          <tr item>
                                            <td class="text-xs-left">
                                              {{ props.item.Kod }}
                                            </td>
                                            <td class="text-xs-left">
                                              {{ props.item.Aciklama }}
                                            </td>
                                            <td class="text-xs-left">
                                              {{ props.item.Yetiskin }}
                                            </td>
                                            <td class="text-xs-left">
                                              {{ props.item.Cocuk1 }}
                                            </td>
                                            <td class="text-xs-left">
                                              {{ props.item.Cocuk2 }}
                                            </td>
                                            <td
                                              class="
                                                justify-end
                                                align-center
                                                full-heigth
                                                layout
                                                px-0
                                              "
                                            >
                                              <v-tooltip bottom>
                                                <v-btn
                                                  icon
                                                  small
                                                  slot="activator"
                                                  flat
                                                  @click="
                                                    openUpdateLowerRoomType(
                                                      props.item
                                                    )
                                                  "
                                                >
                                                  <v-icon color="green"
                                                    >system_update_alt</v-icon
                                                  >
                                                </v-btn>
                                                <span>{{ $t('Update') }}</span>
                                              </v-tooltip>
                                              <v-tooltip bottom>
                                                <v-btn
                                                  @click="
                                                    deleteRoomType(props.item)
                                                  "
                                                  icon
                                                  small
                                                  slot="activator"
                                                  flat
                                                >
                                                  <v-icon color="error"
                                                    >delete</v-icon
                                                  >
                                                </v-btn>
                                                <span> {{ $t('Delete') }} </span>
                                              </v-tooltip>
                                            </td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </v-card-text>
                                  </v-card>
                                  <v-card v-else>
                                    <v-card-text>
                                      {{ $t('Recorded-Room-Type-not-Found') }}
                                    </v-card-text>
                                  </v-card>
                                </template>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-dialog v-model="addRoomTypeDialog" max-width="450px">
            <v-card flat color="grey lighten-4">
              <v-card-title
                v-if="isUpdateRoomType"
                primary-title
                background-color="primary"
              >
                Oda Tipi Güncelle
              </v-card-title>
              <v-card-title v-else primary-title background-color="primary">
                {{ $t('Add-v2', { value: $t('Room-type')}) }}  
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12> </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      :label="$t('Room-Type')"
                      v-model="RoomType.Kod"
                      :disabled="isUpdateRoomType"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      :label="$t('Description')"
                      v-model="RoomType.Aciklama"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <v-text-field
                      :label="$t('Adult')"
                      v-model="RoomType.Yetiskin"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <v-text-field
                      :label="$t('Child') + '1'"
                      v-model="RoomType.Cocuk1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <v-text-field
                      :label="$t('Child') + '2'"
                      v-model="RoomType.Cocuk2"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="info"
                  flat="flat"
                  @click.native="addRoomTypeDialog = false"
                  >{{ $t("cancel_button") }}</v-btn
                >
                <v-btn
                  v-if="isUpdateRoomType"
                  color="info"
                  flat
                  @click="roomTypeSave()"
                  >Guncelle</v-btn
                >
                <v-btn v-else color="info" flat @click="roomTypeSave()"
                  >Kaydet</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="addLowerRoomTypeDialog" max-width="450px">
            <v-card flat color="grey lighten-4">
              <v-card-title
                v-if="isUpdateLowerRoomType"
                primary-title
                background-color="primary"
              >
                Alt Oda Tipi Güncelle
              </v-card-title>
              <v-card-title v-else primary-title background-color="primary">
                Alt Oda Tipi Ekle
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12> </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      :label="$t('Room-Type')"
                      v-model="lowerRoomType.Kod"
                      :disabled="isUpdateLowerRoomType"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      :label="$t('Description')"
                      v-model="lowerRoomType.Aciklama"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <v-text-field
                      :label="$t('Adult')"
                      v-model="lowerRoomType.Yetiskin"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <v-text-field
                      :label="$t('Child') + '1'"
                      v-model="lowerRoomType.Cocuk1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <v-text-field
                      :label="$t('Child') + '2'"
                      v-model="lowerRoomType.Cocuk2"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="info"
                  flat="flat"
                  @click.native="addLowerRoomTypeDialog = false"
                  >{{ $t("cancel_button") }}</v-btn
                >
                <v-btn
                  color="info"
                  v-if="isUpdateLowerRoomType"
                  flat
                  @click="loverRoomTypeSave()"
                  >{{ $t('Update') }}</v-btn
                >
                <v-btn color="info" v-else flat @click="loverRoomTypeSave()"
                  >{{ $t('save_button') }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../coper/tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

export default {
  data() {
    return {
      isUpdateLowerRoomType: false,
      isUpdateRoomType: false,
      expand: false,
      RoomTypeRadio: "AnaTip",
      lowerRoomType: {
        Kod: null,
        Aciklama: null,
        Yetiskin: 0,
        Cocuk1: 0,
        Cocuk2: 0,
      },
      backupRoomType: {
        Kod: null,
        Aciklama: null,
        Yetiskin: 0,
        Cocuk1: 0,
        Cocuk2: 0,
      },
      RoomType: {
        Kod: null,
        Aciklama: null,
        Yetiskin: 0,
        Cocuk1: 0,
        Cocuk2: 0,
      },
      searchara: null,
      addRoomTypeDialog: false,
      addLowerRoomTypeDialog: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      headersadres: [
        {
          text: "",
          value: "Kod",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$t('Code'),
          value: "Kod",
          width: "5%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$t('Description'),
          value: "Aciklama",
          width: "15%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$t('Adult'),
          value: "Yetiskin",
          width: "10%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$t('Child') + " 1",
          value: "Cocuk1",
          width: "10%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$t('Child') + " 2",
          value: "Cocuk2",
          width: "10%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$t('Process'),
          value: "",
          width: "10%",
          align: "right",
          sortable: false,
        },
      ],
      headersadresLower: [
        {
          text: this.$t('Code'),
          value: "Kod",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Description'),
          value: "Aciklama",
          width: "15%",
          align: "left",
        },
        {
          text: this.$t('Adult'),
          value: "Yetiskin",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Child') + " 1",
          value: "Cocuk1",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Child') + " 2",
          value: "Cocuk2",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Process'),
          value: "",
          width: "10%",
          align: "right",
        },
      ],
      valid: true,
      items: [],
      tooltip: false,
      el: null,
      itemsRoomType: [],
      snackbar: false,
      text1: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth("coper-tanitimlar-parametrelist");

    if (this.sayfayetki.Status == true) {
      this.getList();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var urlMain = "#/";
              window.open(urlMain, "_self");
            }
          }
        });
    }
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },

  components: {
    tarihcomp: tarihcomp,
    yetkidialog,
    hatadialog,
    snackbarcomp,
  },
  methods: {
    openUpdateLowerRoomType(val) {
      this.itemsRoomType.forEach((element) => {
        if (element.AltOdaTipleri != null) {
          element.AltOdaTipleri.forEach((data) => {
            if (data.Kod == val.Kod) {
              this.backupRoomType.Kod = element.Kod;
              this.backupRoomType.Aciklama = element.Aciklama;
              this.backupRoomType.Yetiskin = element.Yetiskin;
              this.backupRoomType.Cocuk1 = element.Cocuk1;
              this.backupRoomType.Cocuk2 = element.Cocuk2;
            }
          });
        }
      });
      this.addLowerRoomTypeDialog = true;
      this.isUpdateLowerRoomType = true;
      this.lowerRoomType.Kod = val.Kod;
      this.lowerRoomType.Aciklama = val.Aciklama;
      this.lowerRoomType.Yetiskin = val.Yetiskin;
      this.lowerRoomType.Cocuk1 = val.Cocuk1;
      this.lowerRoomType.Cocuk2 = val.Cocuk2;
    },
    openRoomTypeAddDialog() {
      this.addRoomTypeDialog = true;
      this.isUpdateRoomType = false;
      this.RoomType.Kod = null;
      this.RoomType.Aciklama = null;
      this.RoomType.Yetiskin = 0;
      this.RoomType.Cocuk1 = 0;
      this.RoomType.Cocuk2 = 0;
    },
    openRoomTypeUpateDialog(val) {
      this.isUpdateRoomType = true;
      this.addRoomTypeDialog = true;

      this.RoomType.Kod = val.Kod;
      this.RoomType.Aciklama = val.Aciklama;
      this.RoomType.Yetiskin = val.Yetiskin;
      this.RoomType.Cocuk1 = val.Cocuk1;
      this.RoomType.Cocuk2 = val.Cocuk2;
    },
    loverRoomTypeSave() {
      let params = {
        Ara: null,
        OdaTipi: {
          Kod: this.backupRoomType.Kod,
          Aciklama: this.backupRoomType.Aciklama,
          Yetiskin: this.backupRoomType.Yetiskin,
          Cocuk1: this.backupRoomType.Cocuk1,
          Cocuk2: this.backupRoomType.Cocuk2,
        },
        AltOdaTipi: {
          Kod: this.lowerRoomType.Kod,
          Aciklama: this.lowerRoomType.Aciklama,
          Yetiskin: this.lowerRoomType.Yetiskin,
          Cocuk1: this.lowerRoomType.Cocuk1,
          Cocuk2: this.lowerRoomType.Cocuk2,
        },
      };

      tool.http_post(this, "OdaTipiSave", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.addLowerRoomTypeDialog = false;
            this.getList();
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );
    },
    openLowerRoomType(val) {
      this.isUpdateRoomType = false;
      this.isUpdateLowerRoomType = false;
      this.backupRoomType.Kod = val.Kod;
      this.backupRoomType.Aciklama = val.Aciklama;
      this.backupRoomType.Yetiskin = val.Yetiskin;
      this.backupRoomType.Cocuk1 = val.Cocuk1;
      this.backupRoomType.Cocuk2 = val.Cocuk2;
      this.lowerRoomType.Kod = null;
      this.lowerRoomType.Aciklama = null;
      this.lowerRoomType.Yetiskin = 0;
      this.lowerRoomType.Cocuk1 = 0;
      this.lowerRoomType.Cocuk2 = 0;
      this.addLowerRoomTypeDialog = true;
    },
    roomTypeSave() {
      let params = {
        Ara: null,
        OdaTipi: {
          Kod: null,
          Aciklama: null,
          Yetiskin: 0,
          Cocuk1: 0,
          Cocuk2: 0,
        },
        AltOdaTipi: {
          Kod: null,
          Aciklama: null,
          Yetiskin: 0,
          Cocuk1: 0,
          Cocuk2: 0,
        },
      };
      if (this.RoomTypeRadio === "AnaTip") {
        params.OdaTipi.Kod = this.RoomType.Kod;
        params.OdaTipi.Aciklama = this.RoomType.Aciklama;
        params.OdaTipi.Yetiskin = this.RoomType.Yetiskin;
        params.OdaTipi.Cocuk1 = this.RoomType.Cocuk1;
        params.OdaTipi.Cocuk2 = this.RoomType.Cocuk2;
      } else if (this.RoomTypeRadio === "AltTip") {
        params.AltOdaTipi.Kod = this.RoomType.Kod;
        params.AltOdaTipi.Aciklama = this.RoomType.Aciklama;
        params.AltOdaTipi.Yetiskin = this.RoomType.Yetiskin;
        params.AltOdaTipi.Cocuk1 = this.RoomType.Cocuk1;
        params.AltOdaTipi.Cocuk2 = this.RoomType.Cocuk2;
      }

      tool.http_post(this, "OdaTipiSave", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.addRoomTypeDialog = false;
            this.getList();
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );
    },
    deleteRoomType(val) {
      let params = {
        Ara: null,
        Kod: val.Kod,
      };
      tool.http_post(this, "OdaTipiDelete", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.text1 = "Oda Tipi Silindi";
            this.snackbar = true;
            this.itemsRoomType = response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );
    },
    git(val) {
      var url = "/#/coper/tanitimlar/adres/id?isl=get&id=" + val.Id;
      window.open(url, "_blank", null, true);
    },
    getList: getList,
  },
};

function getList() {
  let params = {
    Ara: this.searchara,
  };
  tool.http_post(this, "OdaTipleriList", params).then(
    (response) => {
      if (response.body.Status == true) {
        this.itemsRoomType = response.body.data;
      } else {
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
      }
    },
    (response) => {
      this.text1 = "Hata Oluştu, tekrar deneyiniz";
      this.snackbar = true;
    }
  );
}

function beforeMount() {}
</script>
<style>
</style>